import { RSA_FRONTEND_MW_PUBLIC_KEY } from '../constants';
import { JSEncrypt } from 'jsencrypt';
var rsa = new JSEncrypt();
rsa.setPublicKey(RSA_FRONTEND_MW_PUBLIC_KEY);
export var encryptString = function (string) {
    if (typeof string !== 'string')
        throw new Error('string should be from type string');
    var encrypted = rsa.encrypt(string);
    if (!encrypted)
        throw new Error('encryption data reached max allowed length');
    return encrypted;
};
